var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoosechaseIconDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 586.53 1000"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M586.53 694.85c0 88.4-27.49 161.25-82.23 218.81-54.86 57.69-125.14 86.34-210.97 86.34s-156.24-28.65-210.97-86.34C44.71 874.09 19.92 827.32 8.1 773.35l533.98-200.82 9.25-3.47 10.54-3.98c16.45 38.8 24.67 82.1 24.67 129.77zM275.6 0C195.68 0 129.77 26.98 77.86 81.2 25.95 135.3 0 203.52 0 285.62s25.83 151.48 77.35 205.7c51.52 54.09 117.69 81.2 198.25 81.2s146.86-27.11 198.38-81.2c51.52-54.22 77.35-122.7 77.35-205.7V0H275.6zm119.36 427.47c-32.51 33.92-72.21 50.88-119.36 50.88s-86.73-16.96-119.23-50.88c-32.51-34.05-48.82-81.33-48.82-141.85s16.32-106.51 48.82-140.56c32.51-34.05 72.21-51.01 119.23-51.01s86.86 16.96 119.36 51.01c32.51 34.05 48.82 80.82 48.82 140.56s-16.32 107.8-48.82 141.85z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M542.08 572.53l9.25-3.47v3.47h-9.25z"
  })));
}

export default SvgGoosechaseIconDark;